import React, { FC } from "react";
import { useTranslation } from "next-i18next";
import { cmsPageProps } from "../lib/pageProps";

import Container from "../layouts/AuthContainer";
import Meta from "../layouts/Meta";
import LoginComponent from "../components/_shared/LoginComponent";

const Login: FC = () => {
  const { t } = useTranslation("login");

  return (
    <Container>
      <Meta
        title={t("title")}
        description={t("meta-description")}
        keywords={t("meta-keyword")}
        noindex
      />
      <LoginComponent />
    </Container>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await cmsPageProps(locale, ["login"])),
  },
  revalidate: 60,
});

export default Login;
